import { BlogPost } from '../types';

export const blogPosts: BlogPost[] = [
  {
    slug: 'ai-fundamentals-for-educators',
    image: '/images/blog/blog-1.png',
    imageAlt: 'AI Fundamentals for Educators',
    title: 'AI Fundamentals for Educators: Getting Started',
    excerpt: 'Learn the essential AI concepts every educator should know to integrate artificial intelligence into their teaching practice effectively.',
    date: '15 Dec 2024',
    readTime: '5 min read',
    tags: ['AI Basics', 'Education'],
    link: '#'
  },
  {
    slug: 'design-thinking-enhanced-by-ai',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Design Thinking with AI',
    title: 'Design Thinking Enhanced by AI: A Practical Guide',
    excerpt: 'Explore how AI tools can amplify the design thinking process, from empathy mapping to rapid prototyping in educational contexts.',
    date: '12 Dec 2024',
    readTime: '7 min read',
    tags: ['Design Thinking', 'AI Tools'],
    link: '#'
  },
  {
    slug: 'fostering-student-ai-collaboration',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Student-AI Collaboration',
    title: 'Fostering Student-AI Collaboration in the Classroom',
    excerpt: 'Discover strategies for creating meaningful partnerships between students and AI tools that enhance learning outcomes and critical thinking.',
    date: '10 Dec 2024',
    readTime: '6 min read',
    tags: ['Collaboration', 'Student Learning'],
    link: '#'
  },
  {
    slug: 'teaching-ai-ethics',
    image: '/images/blog/blog-1.png',
    imageAlt: 'AI Ethics in Education',
    title: 'Teaching AI Ethics: Building Responsible Digital Citizens',
    excerpt: 'Learn how to incorporate AI ethics discussions into your curriculum and help students develop critical thinking about technology\'s impact on society.',
    date: '8 Dec 2024',
    readTime: '8 min read',
    tags: ['AI Ethics', 'Digital Citizenship'],
    link: '#'
  },
  {
    slug: 'ai-powered-assessment-tools',
    image: '/images/blog/blog-1.png',
    imageAlt: 'AI Assessment Tools',
    title: 'AI-Powered Assessment Tools: Enhancing Student Evaluation',
    excerpt: 'Explore innovative AI tools that can help educators create more effective and personalized assessment strategies for their students.',
    date: '5 Dec 2024',
    readTime: '4 min read',
    tags: ['Assessment', 'AI Tools'],
    link: '#'
  },
  {
    slug: 'future-of-ai-in-education',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Future of AI in Education',
    title: 'The Future of AI in Education: Trends and Predictions',
    excerpt: 'Look ahead to emerging trends in AI education and how they might shape the learning landscape in the coming years.',
    date: '3 Dec 2024',
    readTime: '9 min read',
    tags: ['Future Trends', 'Innovation'],
    link: '#'
  }
];

